import React from "react";

import { OriginatorsDataProvider } from "../../../common/data/lookup-data-providers/OriginatorsDataProvider";
import { CloudFileListing } from "./CloudFileListing";
import { CloudFileListingProvider } from "./CloudFileListingProvider";

export const CloudFileListingDashboard: React.VFC = () => {
    return (
        <OriginatorsDataProvider>
            <CloudFileListingProvider>
                <CloudFileListing />
            </CloudFileListingProvider>
        </OriginatorsDataProvider>
    );
};
